import React from "react";
import PropTypes from "prop-types";
import { getLocalPartiName, getParticipantIndex } from "../../shared/dataTrackFunction";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";

const GalleryViewParticipantsName = ({ identity, isVideoStreaming = false, isScreenShareStreaming = false, localisedValues }) => {
    let participantName = getParticipantIndex(identity);
    if (identity == CALL_DATA.localIdentity) {
        participantName = getLocalPartiName();
        if (CALL_DATA.participantUserName && !GLOBAL_MEETING_DATA.isAgent) {
            participantName = CALL_DATA.participantUserName + " " + localisedValues["you"];
        }
    }
    return (
        <div className='participant-name'>
            <span className='name'>{participantName}</span>
            {!isVideoStreaming && !isScreenShareStreaming && <span className='for-icon icon-video-off'></span>}
        </div>
    );
};

GalleryViewParticipantsName.propTypes = {
    identity: PropTypes.string.isRequired,
    isVideoStreaming: PropTypes.bool,
    isScreenShareStreaming: PropTypes.bool,
    localisedValues: PropTypes.any,
};

export default GalleryViewParticipantsName;
